// import React, { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { searchUser, clearSearchResults, setSelectedUser, fetchPremiumDetails } from '../redux/search/SearchSlice';

// import PaystackPop from '@paystack/inline-js';
// import axios from 'axios';

// const Search = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [userType, setUserType] = useState('jobSeeker');
//   const dispatch = useDispatch();
//   const { searchResults, selectedUser, premiumDetails, loading, error } = useSelector((state) => state.search);
//   const { currentUser } = useSelector((state) => state.user);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (searchTerm) {
//       dispatch(searchUser({ searchTerm, userType }));
//     }
//   };

//   const handleViewDetails = (user) => {
//     dispatch(setSelectedUser(user));
//   };

//   const handlePayForPremium = async (userId) => {
//     const paystack = new PaystackPop();
//     paystack.newTransaction({
//       key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY, 
//       email: currentUser.email,
//       amount: 300000, // ₦3000 in kobo
//       onSuccess: async (transaction) => {
//         try {
//           await axios.post(`${process.env.REACT_APP_API_URL}payment/verify`, { reference: transaction.reference, userId }, {
//             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//           });
//           dispatch(fetchPremiumDetails(userId));
//         } catch (error) {
//           console.error('Payment verification failed:', error);
//         }
//       },
//       onCancel: () => {
//         console.log('Payment cancelled');
//       },
//     });
//   };

//   return (
//     <div className="p-4">
//       <form onSubmit={handleSearch} className="flex gap-2">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search for a user"
//           className="border p-2 rounded"
//         />
//         <select
//           value={userType}
//           onChange={(e) => setUserType(e.target.value)}
//           className="border p-2 rounded"
//         >
//           <option value="jobSeeker">Job Seeker</option>
//           <option value="jobEmployer">Employer</option>
//         </select>
//         <button type="submit" disabled={loading} className="bg-blue-500 text-white p-2 rounded">
//           {loading ? 'Searching...' : 'Search'}
//         </button>
//         <button onClick={() => dispatch(clearSearchResults())} className="bg-gray-500 text-white p-2 rounded">
//           Clear
//         </button>
//       </form>
//       {error && <p className="text-red-500">{error}</p>}
//       <h3 className="mt-4">Search Results</h3>
//       <ul className="list-disc pl-5">
//         {searchResults.map((user) => (
//           <li key={user.id}>
//             {user.name} ({user.userType})  {user.jobDecision}  {user.hiredHistory}

//             <button
//               onClick={() => handleViewDetails(user)}
//               className="ml-2 text-blue-500 underline"
//             >
//               View Details
//             </button>
//             {selectedUser?.id === user.id && (
//               <button
//                 onClick={() => handlePayForPremium(user.id)}
//                 className="ml-2 bg-orange-500 text-white p-1 rounded"
//               >
//                 Unlock Premium Details
//               </button>
//             )}
//           </li>
//         ))}
//       </ul>
//       {selectedUser && (
//         <div className="mt-4">
//           <h3>Basic Details</h3>
//           <p>Name: {selectedUser.name}</p>
//           <p>User Type: {selectedUser.userType}</p>
//         </div>
//       )}
//       {premiumDetails && selectedUser?.id === premiumDetails.id && (
//         <div className="mt-4">
//           <h3>Premium Details</h3>
//           <p>Email: {premiumDetails.email}</p>
//           <p>Phone: {premiumDetails.phoneNumber}</p>
//           {premiumDetails.userType === 'jobSeeker' && <p>Job Mode: {premiumDetails.jobMode}</p>}
//           {premiumDetails.userType === 'jobEmployer' && <p>Company Size: {premiumDetails.size}</p>}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Search;





























import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import{ searchUser, clearSearchResults, setSelectedUser, fetchPremiumDetails }  from '../redux/search/SearchSlice';

import PaystackPop from '@paystack/inline-js';
import axios from 'axios';

const Search = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [userType, setUserType] = useState('jobSeeker');
  const dispatch = useDispatch();
  const { searchResults, selectedUser, premiumDetails, loading, error } = useSelector((state) => state.search);
  const { currentUser } = useSelector((state) => state.user);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm && currentUser?.uniqueNumber) {
      console.log('Searching for:', searchTerm, userType);
      dispatch(searchUser({ searchTerm, userType }));
    }
  };

  const handleViewDetails = (user) => {
    dispatch(setSelectedUser(user));
  };

  const handlePayForPremium = async (userId) => {
    const paystack = new PaystackPop();
    paystack.newTransaction({
      key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
      email: currentUser.email,
      amount: 300000, // ₦3000 in kobo
      onSuccess: async (transaction) => {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/verify`, { reference: transaction.reference, userId }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });
          if (response.data.success) {
            dispatch(fetchPremiumDetails(userId));
          }
        } catch (error) {
          console.error('Payment verification failed:', error.response?.data?.message || error.message);
        }
      },
      onCancel: () => {
        console.log('Payment cancelled');
      },
    });
  };

  return (
    <div className="p-4">
      <form onSubmit={handleSearch} className="flex gap-2">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search for a user"
          className="border p-2 rounded"
          disabled={!currentUser}
        />
        <select
          value={userType}
          onChange={(e) => setUserType(e.target.value)}
          className="border p-2 rounded"
          disabled={!currentUser}
        >
          <option value="jobSeeker">Job Seeker</option>
          <option value="jobEmployer">Employer</option>
        </select>
        <button type="submit" disabled={loading || !currentUser} className="bg-blue-500 text-white p-2 rounded">
          {loading ? 'Searching...' : 'Search'}
        </button>
        <button onClick={() => dispatch(clearSearchResults())} className="bg-gray-500 text-white p-2 rounded" disabled={!currentUser}>
          Clear
        </button>
      </form>
      {/* {error && <p className="text-red-500">{error}</p>} */}
      {!currentUser && <p className="text-red-500">Please log in to search</p>}
      <h3 className="mt-4">Search Results</h3>
      {searchResults.length === 0 && <p>No results found</p>}
      <ul className="list-disc pl-5">
        {searchResults.map((user) => (
          <li key={user.id}>
            {user.name} ({user.userType})
            <button
              onClick={() => handleViewDetails(user)}
              className="ml-2 text-blue-500 underline"
            >
              View Details
            </button>
            {selectedUser?.id === user.id && (
              <button
                onClick={() => handlePayForPremium(user.id)}
                className="ml-2 bg-orange-500 text-white p-1 rounded"
              >
                Unlock Premium Details
              </button>
            )}
          </li>
        ))}
      </ul>
      {selectedUser && (
        <div className="mt-4">
          <h3>Basic Details</h3>
          <p>Name: {selectedUser.name}</p>
          <p>User Type: {selectedUser.userType}</p>
        </div>
      )}
      {premiumDetails && selectedUser?.id === premiumDetails.id && (
        <div className="mt-4">
          <h3>Premium Details</h3>
          <p>Email: {premiumDetails.email}</p>
          <p>Phone: {premiumDetails.phoneNumber}</p>
          {premiumDetails.userType === 'jobSeeker' && <p>Job Mode: {premiumDetails.jobMode}</p>}
          {premiumDetails.userType === 'jobEmployer' && <p>Company Size: {premiumDetails.size}</p>}
        </div>
      )}
    </div>
  );
};

export default Search;